<!--  -->
<template>
    <div class="business-content-main" v-loading="saveLoading" element-loading-spinner="none">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">用户昵称</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.Name" v-filter-special-char="searchData.Name" placeholder="用户昵称"></el-input>
                <div class="search-name">电话号码</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.CallNum" v-filter-special-char="searchData.CallNum" placeholder="电话号码"></el-input>
                <div class="search-name">关联的客户</div>
                <el-select
                    size="small"
                    class="search-item"
                    v-model="searchData.EntpCusId"
                    remote
                    filterable
                    clearable
                    allow-create
                    placeholder="用户名称"
                    :remote-method="searchCustom"
                    v-select-scroll-more="searchCustomLoad"
                >
                    <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusId">
                        <div class="name">
                            {{ item.EntpCusName }}
                            <span v-if="item.CallNum" class="phone">{{ ` ( 电话：${item.CallNum} )` }}</span>
                        </div>
                    </el-option>
                </el-select>
                <div class="search-name">加入时间</div>
                <el-date-picker
                    size="small"
                    class="search-name"
                    v-model="datetime1"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                    @change="onDate1TimeSelect"
                ></el-date-picker>
                <el-button class="search-btn btn-primary" size="small" icon="el-icon-search" @click="handleSearch">查询</el-button>
                <el-button class="search-btn btn-primary" size="small" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border="" style="width: 100%; margin-bottom: 0px">
                <el-table-column show-overflow-tooltip width="180px" prop="NickName" label="用户昵称"></el-table-column>
                <el-table-column show-overflow-tooltip width="180px" prop="PhoneNum" label="电话号码"></el-table-column>
                <el-table-column show-overflow-tooltip width="150px" prop="TrueName" label="真实名称">
                    <template slot-scope="scope">
                        {{ !scope.row.TrueName ? '-' : scope.row.TrueName }}
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="180px" prop="CusName" label="客户名称">
                    <template slot-scope="scope">
                        {{ !scope.row.CusName ? '未关联' : scope.row.CusName }}
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="160px" prop="CreateTime" label="加入时间"></el-table-column>
                <!-- <el-table-column show-overflow-tooltip min-width="100px" prop="Remark" label="备注"></el-table-column> -->
                <el-table-column show-overflow-tooltip width="100px" prop="StateName" label="状态">
                    <template slot-scope="scope">
                        <i v-if="scope.row.State==1" style="color:red">{{scope.row.StateName}}</i>
                        <i v-else>{{scope.row.StateName}}</i>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="240px">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button v-if="permission.edit" title="编辑" size="mini" type="text" @click="add(2, scope.row)">{{ permission.edit }}</el-button>
                            <el-button v-if="permission.linkCus && !scope.row.EntpCId" title="关联客户" size="mini" type="text" @click="showLinkDialog(scope.row)">{{
                                permission.linkCus
                            }}</el-button>
                             <el-button v-if="permission.linkCus && scope.row.EntpCId" title="修改客户关联" size="mini" type="text" @click="showLinkDialog(scope.row)">
                                修改客户关联
                            </el-button>
                            <!-- <el-button v-if="permission.authFunc" title="分配权限" size="mini" type="text" @click="add(2, scope.row)">{{
                                permission.authFunc
                            }}</el-button> -->
                            <el-button
                                v-if="permission.banUser && scope.row.State == 0"
                                title="禁用"
                                size="mini"
                                type="text"
                                style="color: red"
                                @click="banUser(scope.row)"
                                >{{ permission.banUser }}</el-button
                            >
                            <el-button
                                v-if="permission.banUser && scope.row.State == 1"
                                title="恢复使用"
                                size="mini"
                                type="text"
                                style="color: orange"
                                @click="banUser(scope.row)"
                            >
                                恢复使用
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" title="客户信息" :visible.sync="dialogVisible" width="1000px">
            <div class="dialog-content" v-if="dialogVisible">
                <customerEdit ref="customerEdit" :cusId="EntpCusId" :type="dialogType" @closeDialog="closeDialog" source="1"></customerEdit>
            </div>
        </el-dialog>

        <el-dialog
            :close-on-click-modal="false"
            title="微信用户关联企业客户"
            :visible.sync="dialogLinkVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-cus-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="dialogLinkVisible">
                <el-form ref="form" label-position="left" label-width="70px">
                    <el-form-item label="客户名称">
                        <el-select
                            ref="search_cus"
                            size="small"
                            v-model="EntpCusId"
                            remote
                            filterable
                            clearable
                            allow-create
                            placeholder="客户名称"
                            :remote-method="searchCustom"
                            v-select-scroll-more="searchCustomLoad"
                            style="width: 100%"
                        >
                            <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusId">
                                <div class="name">
                                    {{ item.EntpCusName }}
                                    <span v-if="item.CallNum" class="phone">{{ ` ( 电话：${item.CallNum} )` }}</span>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="confirmLink">确认关联</el-button>
                    <el-button size="small" @click="closeLinkDialog">关闭（Esc）</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import customerEdit from '@/components/business/customerManage/customerEdit';
import mixin from '@/mixins/mixin';
import breadcrumb from '@/components/common/breadcrumb';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        customerEdit,
        breadcrumb
    },
    data() {
        return {
            isStopReq: false,
            loading: false,
            datetime1: [],
            RsId: '',
            EntpCusId: '',
            EntpCusName: '',
            tagsList: [],
            sourceList: [],
            dialogType: '-1',
            dialogVisible: false,
            dialogLinkVisible: false,
            isShowAdvanceDialog: false,
            searchData: {
                Name: '',
                EntpCusId: '',
                CallNum: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 15
            },
            tableData: [],
            SIdList: [],
            tableDataLength: 0,
            permission: {},
            followsVisible: false,
            columnShowSets: [],
            // 用于客户名称列表，分页搜索
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            isStartSearch: false,
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            saveLoading: false,
            percentage: 0, //进度
            currtPage: 1, //页面，表示保存到第几页,
            saveCount: 0, //已保存数
            showExportMsg: false,
            payWayList: [],
            levelList: []
        };
    },
    watch: {
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.search_cus.focus();
                });
            }
        },
        'bacthUpdateData.UpdateKey'() {
            this.bacthUpdateData.UpdateValue = '';
        }
    },
    activated() {
        document.addEventListener('keydown', this.handleKeyEvent);
    },
    //当前页面使用了keepAlive,不会触发beforeDestroy钩子
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.dialogLinkVisible) this.dialogLinkVisible = false;
        next();
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
    },
    mounted() {
        this.permission = this.$util.getPermission('WeChatUser');
        this.getTableData();
    },
    methods: {
        handleKeyEvent(e) {
            let that = this;
            let key = window.event.keyCode;
            if (key === 13) {
                e.preventDefault();
                that.handleSearch();
                return;
            }
            if (key === 27) {
                e.preventDefault();
                if (that.dialogLinkVisible) {
                    that.dialogLinkVisible = false;
                }
                return;
            }
            //右键
            if (key === 39) {
                e.preventDefault();
                if (!that.dialogLinkVisible) {
                    let page = that.searchData.page;
                    let limit = that.searchData.limit;
                    let totalPages = Math.ceil(that.tableDataLength / limit);
                    if (page < totalPages) {
                        that.searchData.page += 1;
                        that.getTableData();
                    }
                }
                return;
            }
            //左键
            if (key === 37) {
                e.preventDefault();
                if (!that.dialogLinkVisible) {
                    if (that.searchData.page !== 1) {
                        that.searchData.page -= 1;
                        that.getTableData();
                    }
                }
                return;
            }
        },
        // 客户名称列表，搜索
        async searchCustom(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchCustomer(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustom();
        },
        searchTags() {
            let url = '/api/EntpCustomers/GetEnterpriseCustomerTagList';
            this.$util
                .axiosGet({
                    url: url,
                    hideLoading: true
                })
                .then(res => {
                    this.tagsList = res.data;
                });
        },
        closeDialog(edit) {
            this.EntpCusId = '';
            this.dialogVisible = false;
            if (edit) {
                this.getTableData();
            }
        },
        add(type, item) {
            this.EntpCusId = '';
            this.dialogType = type;
            if (type == 2 || type == 3) {
                this.EntpCusId = item.EntpCusId;
            }
            this.dialogVisible = true;
        },
        // 禁用用户
        banUser(row) {
            let that = this;
            let state = row.State == 1 ? '恢复' : '禁用';
            this.$util.elConfirm({
                content: '确定要' + state + '该用户吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: '/api/EntpCustomers/BanWXUsers',
                            data: {
                                RsId: row.RsId
                            }
                        })
                        .then(() => {
                            that.searchData.page = 1;
                            that.$util.successMsg(state + '成功');
                            that.getTableData();
                        })
                        .catch(() => {});
                }
            });
        },
        resetSearch() {
            this.searchData = {
                Name: '',
                EntpCusId: '',
                CallNum: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: this.commonPageSize
            };
            this.datetime1 = [];
        },
        getTableData() {
            if (!this.isStopReq) {
                this.loading = true;
                this.isStopReq = true;
                this.$util
                    .axiosGet({
                        url: '/api/EntpCustomers/GetEntpWXUserList',
                        data: this.searchData,
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        if (!data) data = [];
                        this.tableData = data;
                        if (this.searchData.page == 1) {
                            this.tableDataLength = res.count;
                        }
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.loading = false;
                        this.isStopReq = false;
                    });
            }
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.getTableData();
        },
        getSourceList() {
            this.$util
                .axiosGet({
                    url: '/api/EntpCustomers/GetEnterpriseCustomerSources',
                    hideLoading: true
                })
                .then(res => {
                    this.sourceList = res.data;
                })
                .catch(() => {});
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        handleDBClick(event) {
            if (event) {
                this.add(3, event);
            }
        },
        //当客户标签下拉框出现时触发
        tagVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.tagsList.length == 0) that.searchTags();
            }
        },
        payVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.payWayList.length == 0) {
                    this.$util.getPay().then(data => {
                        this.payWayList = data;
                    });
                }
            }
        },
        sourceVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.sourceList.length == 0) that.getSourceList();
            }
        },
        getSIdList() {
            this.$util.getCommonSIdList().then(data => {
                this.SIdList = data;
            });
        },
        showLinkDialog(item) {
            this.RsId = item.RsId;
            this.dialogLinkVisible = true;
        },
        confirmLink() {
            let that = this;
            that.$util
                .axiosPost({
                    url: '/api/EntpCustomers/LinkEntpCustomer',
                    data: {
                        RsId: that.RsId,
                        EntpCusId: that.EntpCusId
                    }
                })
                .then(() => {
                    that.searchData.page = 1;
                    that.$util.successMsg('关联成功');
                    that.getTableData();
                    that.closeLinkDialog();
                })
                .catch(() => {});
        },
        closeLinkDialog() {
            this.RsId = '';
            this.EntpCusId = '';
            this.dialogLinkVisible = false;
        },
        staffVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.SIdList.length == 0) that.getSIdList();
            }
        },
        showApplyAdvance() {
            this.isShowAdvanceDialog = true;
        },
        closeAdvanceDialog() {
            this.isShowAdvanceDialog = false;
        },
        //选中时间
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        handleSelectionChange(val) {
            let idList = [];
            for (let i = 0; i < val.length; i++) {
                idList.push(val[i].EntpCusId);
            }
            this.bacthUpdateData.CusIds = idList;
        },
        levelVisibleChange(event) {
            let that = this;
            if (event) {
                this.$util.getCusPriceLevels().then(data => {
                    this.levelList = data;
                });
            }
        }
    }
};
</script>
<style lang="less" scoped>
#search-cus-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .search-item-dialog {
        width: 340px;
        height: auto;
        .dialog-footer {
            text-align: right;
        }
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
#apply-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .search-item-dialog {
        width: 340px;
        height: auto;
        .dialog-footer {
            text-align: right;
        }
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
.saveProgress {
    position: absolute;
    top: 45%;
    left: 45%;
    z-index: 9999;
}
.exportmsg {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 10000;
    position: absolute;
    top: 65vh;
    left: 60vh;
    font-size: 22px;
    color: rgb(243, 62, 62);
}
.e-item1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 30%;
}
.e-item2 {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 70%;
}
</style>
